import React, { useEffect } from "react";
import { customFetch } from "../../../../hooks/customFetch";
import useAppContext from "../../../../context/useAppContext";

const Final = (props) => {
  const { innerTexts, tc, token } = useAppContext();
  const eBranchUrl = innerTexts.companyEBranchUrl;
  const eBranchButtonText = innerTexts.companyEBranchButtonText || "E-Şube Giriş";

  const urlencoded = new URLSearchParams();
  urlencoded.append("tc_no", tc);

  useEffect(() => {
    if (props.currentStep === 5) {
      customFetch({
        params: `islem=step_check`,
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        body: urlencoded,
        token: token,
        onSuccess: (res) => {
          if (res.Step === "5") {
            props.setFinished(true);
          }
        },
      });
    }
  }, [props.currentStep]);

  const renderEBranchLink = () => {
    if (!eBranchUrl) {
      return null;
    }

    return (
      <a
        href={eBranchUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-success btn-block"
        style={{ marginBottom: 10 }}
      >
        {eBranchButtonText}
      </a>
    );
  };

  if (
    (innerTexts.noYerindelikUygunlukStep) && (props.currentStep === 4 || props.currentStep === 5)
  ) {
    return (
      <div className="container">
        <div className="row">
          <div
            className="col-md-12"
            style={{ textAlign: "center", marginBottom: 20 }}
          >
            <div className="alert alert-success" role="alert">
              <h2 className="alert-heading">
                {innerTexts.label_step_final_title}
              </h2>
              <h4>{innerTexts.label_step_final_sub_title}</h4>
              <hr />
              <p
                className="mb-0"
                dangerouslySetInnerHTML={{
                  __html: innerTexts.label_step_final_description,
                }}
              ></p>
            </div>
            {renderEBranchLink()}
            <button
              onClick={() => {
                window.location.replace("" + innerTexts.companyHomePage);
              }}
              className="btn btn-primary btn-block"
            >
              Anasayfa'ya Git
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!innerTexts.customSteps && props.currentStep === 5) {
    return (
      <div className="container">
        <div className="row">
          <div
            className="col-md-12"
            style={{ textAlign: "center", marginBottom: 20 }}
          >
            <div className="alert alert-success" role="alert">
              <h2 className="alert-heading">
                {innerTexts.label_step_final_title}
              </h2>
              <h4>{innerTexts.label_step_final_sub_title}</h4>
              <hr />
              <p className="mb-0">{innerTexts.label_step_final_description}</p>
            </div>
            {renderEBranchLink()}
            <button
              onClick={() => {
                window.location.replace("" + innerTexts.companyHomePage);
              }}
              className="btn btn-primary btn-block"
            >
              Anasayfa'ya Git
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default Final;
